module.exports = __webpack_public_path__ + "img/integralIcon.b6c9726b.png";